// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScenarioTree_scenarioTreeContainer__4z1QA {
  margin-top: 16px;
  padding: 12px;
  background-color: #f0f9ff;
  border-radius: 6px;
  border: 1px solid #b8d4e3;
  max-height: 300px;
  overflow-y: auto;
}

.ScenarioTree_scenarioLabel__fhFSI {
  font-size: 13px;
  font-weight: 600;
  color: #2b6cb0;
  margin-bottom: 8px;
}

.ScenarioTree_scenarioTree__-fBD7 {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/PreviewTesterHome/PreviewEditorHome/ScenarioTree.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".scenarioTreeContainer {\n  margin-top: 16px;\n  padding: 12px;\n  background-color: #f0f9ff;\n  border-radius: 6px;\n  border: 1px solid #b8d4e3;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.scenarioLabel {\n  font-size: 13px;\n  font-weight: 600;\n  color: #2b6cb0;\n  margin-bottom: 8px;\n}\n\n.scenarioTree {\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scenarioTreeContainer": `ScenarioTree_scenarioTreeContainer__4z1QA`,
	"scenarioLabel": `ScenarioTree_scenarioLabel__fhFSI`,
	"scenarioTree": `ScenarioTree_scenarioTree__-fBD7`
};
export default ___CSS_LOADER_EXPORT___;
